// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.scrollTop {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background: #1e2150;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  cursor: pointer;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}
.scrollTop:hover {
  transform: translateY(6px);
  background: rgb(18.8727272727, 20.76, 50.3272727273);
}
.scrollTop.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* 📱 Mobile */
@media (max-width: 600px) {
  .scrollTop {
    width: 48px;
    height: 48px;
    font-size: 18px;
    right: 16px;
    bottom: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styleService/scrollTop.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,mBCMW;EDLX,WAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;EACA,eAAA;EACA,aAAA;EAEA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,mEAAA;EAEA,0CAAA;AANF;AAQE;EACE,0BAAA;EACA,oDAAA;AANJ;AASE;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AAPJ;;AAWA,cAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,WAAA;IACA,YAAA;EARF;AACF","sourcesContent":["@use \"../variables\" as v;\r\n\r\n.scrollTop {\r\n  position: fixed;\r\n  right: 20px;\r\n  bottom: 20px;\r\n\r\n  width: 55px;\r\n  height: 55px;\r\n  border-radius: 50%;\r\n\r\n  background: v.$brand-blue;\r\n  color: #fff;\r\n  border: none;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  font-size: 22px;\r\n  cursor: pointer;\r\n  z-index: 9999;\r\n\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transform: translateY(10px);\r\n  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;\r\n\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);\r\n\r\n  &:hover {\r\n    transform: translateY(6px);\r\n    background: darken(v.$brand-blue, 8%);\r\n  }\r\n\r\n  &.show {\r\n    opacity: 1;\r\n    visibility: visible;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* 📱 Mobile */\r\n@media (max-width: 600px) {\r\n  .scrollTop {\r\n    width: 48px;\r\n    height: 48px;\r\n    font-size: 18px;\r\n    right: 16px;\r\n    bottom: 16px;\r\n  }\r\n}\r\n","// =========================\r\n// Typography\r\n// =========================\r\n$font-base: \"Noto Sans Armenian\",\r\n-apple-system,\r\nBlinkMacSystemFont,\r\n\"Segoe UI\",\r\nRoboto,\r\nOxygen,\r\nUbuntu,\r\nCantarell,\r\n\"Helvetica Neue\",\r\nsans-serif;\r\n\r\n// =========================\r\n// Brand Colors\r\n// =========================\r\n$brand-blue: #1e2150;\r\n$brand-green: #9eba44;\r\n\r\n// Base Colors\r\n$primary: $brand-blue;\r\n$secondary: $brand-green;\r\n$accent: #facc15;\r\n\r\n$light: #ffffff;\r\n$dark: #111827;\r\n$gray: #6b7280;\r\n$text-muted: #555;\r\n\r\n// Backgrounds\r\n$bg-light: #f9fafb;\r\n$bg-alt: #f0f0f5;\r\n$bg-gray: #f6f6f6;\r\n\r\n// Layout\r\n$max-width: 1400px;\r\n$layout-padding-x: 70px;\r\n\r\n// Spacing\r\n$spacing-xs: 0.25rem;\r\n$spacing-sm: 0.5rem;\r\n$spacing-md: 1rem;\r\n$spacing-lg: 2rem;\r\n$spacing-xl: 4rem;\r\n\r\n// Radius\r\n$radius-xs: 4px;\r\n$radius-sm: 8px;\r\n$radius-md: 12px;\r\n$radius-lg: 20px;\r\n$radius-round: 999px;\r\n\r\n// Shadows\r\n$shadow-medium: 0 4px 18px rgba(0, 0, 0, 0.15);\r\n\r\n// Transitions\r\n$transition-fast: 0.2s;\r\n$transition-normal: 0.3s;\r\n$transition-slow: 0.5s;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
